import Vue from 'vue';
import { BootstrapVue, BIcon } from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.component('BIcon', BIcon);
